import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Landmark, Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center p-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/assets/bharatbest-logo.png" alt="BharatBest Fintech" className="h-12 w-auto mx-auto rounded-lg bg-white px-2 py-1" />
          <p className="text-sm text-white/50 mt-3">Sign in to manage leads & content</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-7 space-y-4 shadow-2xl" data-testid="admin-login-form">
          {error && <div role="alert" className="rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3" data-testid="login-error">{error}</div>}
          <div>
            <label htmlFor="login-email" className="text-xs font-bold text-brand-dark uppercase tracking-wider">Email</label>
            <input id="login-email" data-testid="login-email-input" type="email" required className="input-site mt-1.5"
              value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@bharatbestfintech.com" />
          </div>
          <div>
            <label htmlFor="login-password" className="text-xs font-bold text-brand-dark uppercase tracking-wider">Password</label>
            <input id="login-password" data-testid="login-password-input" type="password" required className="input-site mt-1.5"
              value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit-btn" className="btn-primary w-full">
            {loading ? <Loader2 size={16} className="animate-spin" /> : "Sign In"}
          </button>
        </form>
        <p className="text-center text-xs text-white/30 mt-6">Authorized personnel only. All activity is logged.</p>
      </div>
    </div>
  );
}
